import * as yup from 'yup';
import { strings } from '@constants/strings';

export const getVideoFormInitialValues = () => {
  return { url: '' };
};

export const getVideoFormValidationSchema = () => {
  return yup.object().shape({
    url: yup.string().url(strings?.field_not_valid_msg).required(strings?.field_not_valid_msg),
  });
};
